{
  "accountScreen": {
    "downloadCta": "Скачать подписанный документ",
    "helpDescription": "Напишите нам на <underline>{{email}}</underline>",
    "helpTitle": "Нужна помощь или есть вопросы?",
    "loggedInWith": "Вы вошли через {{method}}",
    "title": "Аккаунт",
    "usernameLoginMethod": "Имя пользователя"
  },
  "addHouseholdMemberScreen": {
    "addAnother": "Добавить еще одного",
    "addingMemberDescription": "Нам нужно знать, кто живет вместе с вами.",
    "addingMemberTitle": "Расскажите о них",
    "age": "Возраст",
    "coverageCheck": {
      "dateOfBirth": "Дата рождения (необязательно)",
      "description": "Это поможет нам найти страховку, которая у них уже может быть.",
      "medicaidId": "ID Medicaid (необязательно)",
      "medicaidIdPlaceholder": "Введите ID Medicaid",
      "ssn": "Номер соцстрахования (необязательно)",
      "ssnPlaceholder": "XXX-XX-XXXX",
      "title": "Помогите нам проверить их страховку"
    },
    "duplicateDialog": {
      "cancel": "Нет, вернуться",
      "checkError": "Не удалось проверить список членов вашей семьи. Попробуйте еще раз.",
      "confirm": "Да, это другой человек",
      "description": "Вы уже добавили человека по имени <bold>{{name}}</bold>. Сейчас вы добавляете другого человека?",
      "descriptionWithDetails": "Вы уже добавили человека по имени <bold>{{name}}</bold> ({{details}}). Сейчас вы добавляете другого человека?",
      "reminder": "Не нужно повторно добавлять тех, кого вы уже добавили.",
      "title": "Это другой человек?"
    },
    "enterDateOfBirth": "Вместо этого указать дату рождения",
    "enterRelationship": "Укажите родство",
    "firstName": "Имя",
    "formSubmission": {
      "error": "Мы не смогли добавить этого члена семьи. Попробуйте еще раз.",
      "success": "{{firstName}} успешно добавлен(а)"
    },
    "lastName": "Фамилия",
    "livingWithMe": "Живет со мной",
    "relationshipToMe": "Кем вам приходится",
    "sameMailingAddress": "Тот же почтовый адрес",
    "updateFormSubmission": {
      "success": "{{firstName}} успешно обновлен(а)"
    },
    "validations": {
      "ageOrDateOfBirthRequired": "Пожалуйста, введите возраст или дату рождения.",
      "futureDateOfBirth": "Пожалуйста, введите дату рождения, совпадающую с сегодняшним днем или предшествующую ему.",
      "invalidDateOfBirth": "Пожалуйста, введите правильную дату рождения (ММ/ДД/ГГГГ).",
      "selectAnOption": "Пожалуйста, выберите один из вариантов.",
      "specifyRelationship": "Пожалуйста, укажите, кем вам приходится этот человек."
    }
  },
  "appFooter": {
    "partnershipLabel": "В партнерстве с"
  },
  "appHeader": {
    "toggleThemeTooltip": "Переключатель темы временный для отладки."
  },
  "appMenu": {
    "account": "Аккаунт",
    "household": "Семья",
    "language": "Язык",
    "logout": "Выйти"
  },
  "applicantDocuments": {
    "alsoCompleted": "Этот документ также завершил раздел {{section}}.",
    "alsoCompletedResidenceForMembers": "Этот документ также завершил {{section}} для членов домохозяйства, проживающих по тому же адресу",
    "deleteDialog": {
      "description": "Вы уверены, что хотите удалить этот документ? Это действие нельзя отменить.",
      "title": "Удалить документ"
    },
    "deleteToast": {
      "error": "Мы не смогли удалить этот документ. Попробуйте еще раз.",
      "success": "Документ успешно удален"
    },
    "immigrationIncomplete": {
      "description": "Вам всё ещё нужно загрузить ID номер USCIS, иммиграционные документы и одобрения или I-20, чтобы завершить раздел {{section}}.",
      "dismiss": "Понятно",
      "title": "Нужен ещё один документ"
    },
    "optional": "Необязательно",
    "progress": "Готово: {{completeCount}} из {{applicableCount}}",
    "selectDocumentType": "Выберите тип документа",
    "ssn": {
      "cardOption": "Или загрузите вашу карточку соцстрахования",
      "label": "Номер соцстрахования",
      "save": "Сохранить",
      "saveError": "Мы не смогли сохранить этот номер. Попробуйте еще раз.",
      "saved": "Номер соцстрахования сохранён"
    },
    "supportedFiles": "Форматы: PDF, JPG, PNG",
    "upload": {
      "failed": "Этот документ не удалось загрузить. Попробуйте еще раз.",
      "failedDescription": "Мы не смогли прочитать этот файл. Пожалуйста, удалите его и загрузите заново.",
      "uploading": "Загрузка..."
    },
    "uploadOne": "Загрузите <bold>хотя бы один:</bold>"
  },
  "applicationAddressScreen": {
    "description": "Пожалуйста, проверьте домашний и почтовый адреса всех членов семьи.",
    "homeAddress": "Домашний адрес",
    "isHomeless": "Нет домашнего адреса",
    "mailingAddress": "Почтовый адрес",
    "needsHomeAddress": "<italic>Нужен домашний адрес</italic>",
    "needsMailingAddress": "<italic>Нужен почтовый адрес</italic>",
    "noMailingAddress": "Нет почтового адреса",
    "sameHomeAddress": "Тот же домашний адрес",
    "sameMailingAddress": "Тот же почтовый адрес",
    "title": "Информация об адресе",
    "updateHouseholdAddressesDialog": {
      "addressTypeHome": "домашний адрес",
      "addressTypeHomeAndMailing": "домашний и почтовый адрес",
      "addressTypeMailing": "почтовый адрес",
      "description_one": "{{householdName}} и {{count}} другой в настоящее время используют ваш {{addressType}}. Хотите обновить их адреса тоже?",
      "description_other": "{{householdName}} и {{count}} других в настоящее время используют ваш {{addressType}}. Хотите обновить их адреса тоже?",
      "description_zero": "{{householdName}} в настоящее время использует ваш {{addressType}}. Хотите обновить их адрес тоже?",
      "onlyUpdateMine": "Нет, обновить только мой",
      "title": "Обновить адреса членов семьи",
      "updateMembers_one": "Обновить {{count}} участника",
      "updateMembers_other": "Обновить {{count}} участников"
    },
    "you": "{{name}} (Вы)"
  },
  "applicationChildCaregiverStatusScreen": {
    "description": "Дети должны <bold>жить с вами более полугода</bold>, и вы должны <bold>оплачивать больше половины</bold> их расходов (еда, жилье, учеба, лечение). Сюда входят и некровные родственники.",
    "title": "Живут ли эти члены семьи с детьми до 19 лет и заботятся ли о них?"
  },
  "applicationCitizenshipStatusScreen": {
    "description": "Являются ли <bold>{{householdMembersNames}}</bold> гражданами США?",
    "hintDescription": "Если вы выберете <bold>Нет</bold> — не волнуйтесь. Есть другие варианты участия в программах в зависимости от иммиграционного статуса.",
    "noDescription": "Некоторые или все не являются гражданами США",
    "title": "Право на участие",
    "yesDescription": "Все в списке — граждане США"
  },
  "applicationConfirmationScreen": {
    "brokerDeclined": {
      "description": "Выберите «Да, свяжите меня», чтобы получить помощь: остаться со своими врачами и оформить страховку для всей семьи в одном месте.",
      "summaryWithMedicaid": "Мы проверим вашу заявку на Medicaid и свяжемся с вами, если что-то понадобится. Вам всё равно нужен лицензированный страховой агент, чтобы завершить регистрацию в {{programs}}.",
      "summaryWithoutMedicaid": "Мы получили то, что вы отправили. Вам всё равно нужен лицензированный страховой агент, чтобы завершить регистрацию в {{programs}}.",
      "title": "Вы решили не связываться с лицензированным страховым агентом. Вы уверены?"
    },
    "continueButton": "Продолжить",
    "description": "Наша команда проверит ваши заявки и свяжется с вами, если что-то понадобится. Когда всё будет в порядке, мы передадим их в выбранные вами программы.",
    "title": "Мы получили ваши заявки!"
  },
  "applicationCoverageStatusScreen": {
    "description": "Есть ли у <bold>{{householdMembersNames}}</bold> медицинская страховка? Укажите также покрытие, которое скоро начнёт действовать.",
    "noDescription": "Ни у кого нет страховки",
    "pleaseSpecify": "Пожалуйста, уточните",
    "title": "Статус страховки",
    "whatType": "Какой тип страховки?",
    "who": "У кого есть страховка?",
    "yesDescription": "У кого-то есть страховка"
  },
  "applicationDateOfBirthScreen": {
    "description": "Пожалуйста, добавьте и подтвердите даты рождения для всех членов семьи",
    "success": "Все даты рождения сохранены",
    "title": "Дата рождения"
  },
  "applicationDocuments": {
    "description": "Эти документы нужны, чтобы подтвердить данные в вашей заявке. Вы можете загрузить их сейчас или позже.",
    "title": "Загрузка документов"
  },
  "applicationExpensesScreen": {
    "addAnotherExpense": "Добавить еще один расход",
    "addExpense": "Добавить расход",
    "description": "Укажите медицинские и другие расходы для каждого члена семьи.",
    "expenseTypes": {
      "ALIMONY_PAID": "Алименты",
      "CHILDCARE": "Присмотр за детьми",
      "IRA_CONTRIBUTIONS": "Взносы в пенсионный фонд (IRA)",
      "MEDICAL_EXPENSES": "Медицинские расходы",
      "MOVING_EXPENSES": "Расходы на переезд",
      "NONE": "Нет",
      "OTHER": "Другое",
      "STUDENT_LOANS": "Студенческие кредиты",
      "TUITION_FEES": "Оплата обучения"
    },
    "memberDialog": {
      "alertDescriptions": {
        "MEDICAL_EXPENSES": "Позже мы попросим загрузить подтверждение (счета или чеки из аптек), поэтому держите их под рукой.",
        "OTHER": "Позже мы попросим загрузить подтверждение, подготовьте его заранее.",
        "STUDENT_LOANS": "Позже мы попросим загрузить подтверждение (например, письма по кредиту), подготовьте их заранее."
      },
      "medicalExpenses3MonthsHelpNeededStatus": "Нужна ли вам помощь в оплате медицинских счетов за последние 3 месяца?",
      "title": "Выберите тип расхода"
    },
    "monthlyExpense": "{{monthlyExpense}} / месяц",
    "progress": "Готово: {{progress}} из {{total}}",
    "title": "Расходы семьи"
  },
  "applicationFlow": {
    "amountPerMonth": "Сумма в месяц"
  },
  "applicationForm": {
    "applyingToCounter": "Подача в {{programsCount}} программ для {{householdMembersCount}} чел.",
    "continueButton": "Перейти к заявкам",
    "greatNews": "Отличные новости!",
    "letsCreateApplications": "Давайте оформим заявки для всех.",
    "mayBeEligible": "<bold>{{names}}</bold> могут иметь право",
    "mayBeEligibleFor": "{{memberNames}} могут иметь право на <bold>{{brand}}</bold>",
    "notEligible": "Нет права на участие на данный момент",
    "programConflictDialog": {
      "description": "Подача заявки на {{newProgram}} удалит заявку на {{currentPrograms}} для {{memberNames}}. {{memberNames}} не может подать заявку на обе программы одновременно. После отправки мы позаботимся о том, чтобы для {{memberNames}} была выбрана правильная программа.",
      "description_members": "Подача заявки на {{newProgram}} удалит заявки на {{currentPrograms}} для {{memberNames}}. {{memberNames}} не могут подать заявку на обе программы одновременно. После отправки мы позаботимся о том, чтобы для {{memberNames}} были выбраны правильные программы.",
      "description_self": "Подача заявки на {{newProgram}} удалит вашу заявку на {{currentPrograms}}. Нельзя подать заявку на обе программы одновременно. После отправки мы позаботимся о том, чтобы вы оказались в правильной программе.",
      "keepButton": "Оставить {{currentPrograms}}",
      "multipleDescription": "Подача заявки на {{newProgram}} удалит заявки на {{currentPrograms}} для {{memberNames}}. {{memberNames}} не может подать заявку на все эти программы одновременно. После отправки мы позаботимся о том, чтобы для {{memberNames}} была выбрана правильная программа.",
      "multipleDescription_members": "Подача заявки на {{newProgram}} удалит заявки на {{currentPrograms}} для {{memberNames}}. {{memberNames}} не могут подать заявку на все эти программы одновременно. После отправки мы позаботимся о том, чтобы для {{memberNames}} были выбраны правильные программы.",
      "multipleDescription_self": "Подача заявки на {{newProgram}} удалит ваши заявки на {{currentPrograms}}. Нельзя подать заявку на все эти программы одновременно. После отправки мы позаботимся о том, чтобы вы оказались в правильной программе.",
      "recommendMedicaidDescription": "{{memberNames}} не может подать заявку на обе программы одновременно. Medicaid бесплатна, и {{memberNames}} имеет на неё право. После отправки мы позаботимся о том, чтобы для {{memberNames}} была выбрана правильная программа.",
      "recommendMedicaidDescription_members": "{{memberNames}} не могут подать заявку на обе программы одновременно. Medicaid бесплатна, и {{memberNames}} имеют на неё право. После отправки мы позаботимся о том, чтобы для {{memberNames}} были выбраны правильные программы.",
      "recommendMedicaidDescription_self": "Нельзя подать заявку на обе программы одновременно. Medicaid бесплатна, и вы имеете на неё право. После отправки мы позаботимся о том, чтобы вы оказались в правильной программе.",
      "recommendMedicaidTitle": "Мы рекомендуем подать заявку на Medicaid",
      "switchButton": "Перейти на {{newProgram}}",
      "title": "Вы можете подать заявку только на одну программу"
    },
    "programsFound": "Мы нашли {{programsCount}} подходящих программ для всех {{householdMembersCount}} членов семьи.",
    "recentDuplicateDialog": {
      "continueAnyway": "Все равно продолжить",
      "description": "Недавно вы подали заявление на <bold>{{applicationType}}</bold> для {{memberNames}}. Новое заявление следует подавать только в том случае, если что-то изменилось.",
      "multipleDescription": "Недавно вы подали заявления на <bold>{{applicationTypes}}</bold> для {{memberNames}}. Новое заявление следует подавать только в том случае, если что-то изменилось.",
      "title": "Вы недавно подали заявление"
    },
    "startButton": "Начать оформление заявок"
  },
  "applicationMaritalStatusScreen": {
    "description": "Мы указали семейное положение на основе данных о вашей семье. Пожалуйста, проверьте и исправьте, если нужно.",
    "needsMaritalStatus": "Укажите семейное положение",
    "title": "Семейное положение"
  },
  "applicationOtherStatusesScreen": {
    "conditions": {
      "americanIndianOrAlaskaNative": "Индеец США или коренной житель Аляски",
      "needsHelpDailyActivities": "Нужна помощь в повседневных делах",
      "studentFullTime18to20": "Студент очного отделения (18–20 лет)",
      "veteranOrMilitaryMember": "Ветеран или военнослужащий"
    },
    "description": "Отметьте, если это относится к кому-то из членов семьи.",
    "errors": {
      "unableToUpdateHouseholdMembers": "Не удалось сохранить изменения. Попробуйте еще раз."
    },
    "title": "Другие статусы"
  },
  "applicationSection": {
    "applications": "Заявки",
    "beginYourApplicationCompact": "Оформите заявку за 15 минут",
    "beginYourApplicationProcess": "Начните оформление и получите страховку за 15 минут",
    "continueQuickApply": "Продолжить быстрое оформление",
    "continueYourApplicationCompact": "Продолжите оформление",
    "continueYourApplicationProcess": "Продолжите оформление и получите страховку за 15 минут",
    "newQuickApply": "Новое быстрое оформление",
    "quickApply": "Быстрое оформление"
  },
  "applicationSubmitScreen": {
    "description": "Вы прошли все шаги. Когда будете готовы, отправьте заявки ниже.",
    "hintMessage": "После отправки данные нельзя изменить, поэтому проверьте всё еще раз.",
    "partialFailure": "Возможно, некоторые ваши заявления на страховку не были отправлены. Пожалуйста, проверьте их в списке.",
    "submitButton": "Отправить заявки",
    "success": "Заявки успешно отправлены.",
    "title": "Всё готово!"
  },
  "applicationTaxInformationScreen": {
    "description": "Мы указали налоговый статус на основе ваших данных. Пожалуйста, проверьте и исправьте, если нужно.",
    "errors": {
      "unableToUpdateRelationship": "Не удалось обновить информацию о родстве. Попробуйте еще раз."
    },
    "memberCard": {
      "dependentOf": "Иждивенец у: {{name}}",
      "dependents": "Иждивенцы: {{name}}",
      "memberDialog": {
        "description": "Проверьте и обновите налоговые данные этого человека.",
        "saveAndReturn": "Сохранить и вернуться",
        "taxClaimedAsDependentStatus": "Будет ли кто-то указывать этого человека как иждивенца?",
        "taxDependentsClaimedStatus": "Будет ли этот человек указывать кого-то как иждивенца?",
        "taxFilingStatus": "Налоговый статус",
        "title": "Налоги — {{name}}",
        "who": "Кто именно?"
      }
    },
    "needsTaxInformation": "Нужны данные о налогах",
    "success": "Налоговая информация обновлена",
    "title": "Налоговая информация"
  },
  "applicationWorkAndIncomeScreen": {
    "addAnotherIncome": "Добавить еще один доход",
    "addIncome": "Добавить доход",
    "description": "Добавьте данные о работе и доходах для каждого члена семьи.",
    "incomeTypes": {
      "ALIMONY": "Алименты",
      "EMPLOYED": "Работа по найму",
      "NONE": "Нет",
      "OTHER": "Другое",
      "PENSION": "Пенсия",
      "PROPERTY_RENTAL_INCOME": "Доход от сдачи жилья",
      "RETIREMENT_INCOME": "Пенсионные выплаты",
      "SELF_EMPLOYED": "Самозанятость",
      "SSA": "SSA (соцобеспечение)",
      "SSDI": "SSDI (по инвалидности)",
      "UNEMPLOYED": "Безработный",
      "WORKERS_COMPENSATION": "Страховая выплата работнику"
    },
    "memberDialog": {
      "alertDescriptions": {
        "EMPLOYED": "Позже мы попросим загрузить подтверждение (квитанции или W-2), подготовьте их заранее.",
        "OTHER": "Позже мы попросим загрузить подтверждение (например, письма о выплатах), подготовьте их заранее.",
        "SELF_EMPLOYED": "Позже мы попросим загрузить подтверждение (счета или 1099), подготовьте их заранее.",
        "UNEMPLOYED": "Позже мы попросим подтверждение выплат по безработице, подготовьте их заранее."
      },
      "employerName": "Название работодателя",
      "enterName": "Введите название",
      "enterTypeOfWork": "Введите вид деятельности",
      "grossMonthlyIncome": "Месячный доход (до вычета налогов)",
      "payFrequency": "Как часто платят",
      "selfEmploymentNetMonthlyIncome": "Ожидаемый чистый доход в месяц (после расходов)",
      "title": "Выберите тип дохода",
      "typeOfWork": "Вид деятельности",
      "unemploymentCompensationStatus": "Получаете ли вы пособие по безработице?",
      "workWeekHours": "Часов в неделю"
    },
    "monthlyIncome": "{{monthlyIncome}} / месяц",
    "title": "Работа и доход"
  },
  "applicationsListScreen": {
    "applicationDate": "DD.MM.YYYY [в] h:mm A",
    "inProgress": "В процессе",
    "noApplications": "У вас пока нет заявок.",
    "submitted": "Отправлено",
    "title": "Заявки: {{applicationType}}"
  },
  "authScreen": {
    "appleSignInFailed": "Мы не смогли войти через Apple. Попробуйте еще раз или выберите другой способ.",
    "checkYourEmail": "Проверьте почту",
    "checkYourSpam": "Не пришло? Проверьте папку «Спам» или подождите пару минут.",
    "continueWithApple": "Войти через Apple",
    "continueWithGoogle": "Войти через Google",
    "dataSecured": "Ваши данные под надежной защитой (HIPAA и SOC 2).",
    "emailInput": "Электронная почта",
    "googleSignInFailed": "Мы не смогли войти через Google. Попробуйте еще раз или выберите другой способ.",
    "identifierInput": "Электронная почта или имя пользователя",
    "invalidIdentifier": "Введите корректную электронную почту или имя пользователя.",
    "subtitle": "Введите электронную почту или имя пользователя, чтобы продолжить.",
    "title": "Войти или создать аккаунт",
    "weSentALink": "Мы отправили ссылку на <bold>{{email}}</bold>. Перейдите по ней, чтобы продолжить.",
    "youAgree": "Продолжая, вы соглашаетесь с <underline><colorEmphasis>Условиями использования</colorEmphasis></underline> и <privacyLink><colorEmphasis>Политикой конфиденциальности</colorEmphasis></privacyLink>."
  },
  "brokerConsent": {
    "noButton": "Нет, спасибо",
    "recommendedBadge": "Рекомендуется",
    "yesButton": "Да, свяжите меня"
  },
  "brokerConsentScreen": {
    "continueWithMedicaidOnlyButton": "Продолжить только с Medicaid",
    "continueWithoutAgentButton": "Продолжить без агента",
    "declineCard": {
      "applyLink": "Подать заявку в {{program}}",
      "fallbackWithMedicaid": "Вы всё равно можете продолжить заявку на Medicaid здесь. Pointcare может обработать вашу заявку на Medicaid без агента.",
      "fallbackWithoutMedicaid": "Вы всё равно можете продолжить заявку здесь. Если завершить её сейчас, Pointcare сможет помочь вам, когда изменятся ваши потребности в страховании.",
      "selfEnrollmentWarning": "Без агента вам придётся самостоятельно зарегистрироваться в {{programs}}.",
      "title": "Выберите «Да, свяжите меня», чтобы получить максимум от Pointcare"
    },
    "subtitle": "Мы свяжем вас, когда придёт время регистрации, и поделимся только тем, что нужно для помощи.",
    "subtitleWithIndividual": "Мы свяжем вас, когда придёт время регистрации, и поделимся только тем, что нужно для помощи. Если вы подаёте заявку на Medicare, этим агентом будет {{brokerName}}.",
    "subtitleWithIndividualLicense": "Мы свяжем вас, когда придёт время регистрации, и поделимся только тем, что нужно для помощи. Если вы подаёте заявку на Medicare, этим агентом будет {{brokerName}} (Номер лицензии: {{licenseNumber}}).",
    "subtitleWithOrganization": "Мы свяжем вас, когда придёт время регистрации, и поделимся только тем, что нужно для помощи. Если вы подаёте заявку на Medicare, этот агент будет представлять {{brokerName}}.",
    "subtitleWithOrganizationLicense": "Мы свяжем вас, когда придёт время регистрации, и поделимся только тем, что нужно для помощи. Если вы подаёте заявку на Medicare, этот агент будет представлять {{brokerName}} (Номер лицензии: {{licenseNumber}}).",
    "title": "Свяжитесь с лицензированным страховым агентом, чтобы изучить варианты Medicare и/или Маркетплейса ACA и получить помощь в завершении регистрации"
  },
  "camera": {
    "grantPermission": "Разрешить доступ",
    "permissionDescription": "Чтобы сфотографировать документы, разрешите доступ к камере в настройках телефона.",
    "permissionRequired": "Нам нужен доступ к вашей камере.",
    "photoCount": "Фотографий сделано: {{count}}",
    "tapToCapture": "Нажмите на кнопку, чтобы сделать фото"
  },
  "cesSurvey": {
    "feedbackLabel": "Что показалось сложным?",
    "feedbackPlaceholder": "Расскажите подробнее",
    "optionalLabel": "Необязательно",
    "questions": {
      "consentFormSigned": "Насколько легко было понять, что вы подписываете?",
      "householdMemberAdded": "Насколько легко было добавить члена семьи?",
      "incomeAdded": "Насколько легко было добавить доход?"
    },
    "scoreEasy": "Легко",
    "scoreHard": "Сложно",
    "scoreOk": "Нормально",
    "scoreVeryEasy": "Очень легко",
    "scoreVeryHard": "Очень сложно",
    "thanksDescription": "Ваш отзыв помогает нам становиться лучше.",
    "thanksTitle": "Спасибо!"
  },
  "consentDocuments": {
    "addSignature": "Добавить подпись",
    "description": "Подпишите ниже, чтобы мы могли вам помочь.",
    "documentTitle": "Разрешение на передачу данных (PDF)",
    "grant1": "Следить за вашей страховкой и вовремя находить проблемы",
    "grant2": "Отвечать на запросы вместо вас — никакой потерянной почты",
    "grant3": "Подавать заявки и продления и напоминать о них, чтобы вы не пропустили сроки",
    "grant4": "Связываться с вами в маркетинговых целях по телефону (обычному или автоматическому), через голосовые сообщения и СМС",
    "grantHealthPlanSelection": "Применить выбранный вами план медицинского страхования и врача (когда доступно) к вашему покрытию",
    "grantSubtitle": "Вот что это включает:",
    "healthPlanAvailabilityError": "Не удалось проверить доступные планы медицинского страхования. Пожалуйста, повторите попытку перед подписанием.",
    "signatureCountsAsInitials": "Ваша подпись также считается вашими инициалами в форме, где это применимо.",
    "title": "Управление страховкой вашей семьи",
    "viewDocument": "Посмотреть документ"
  },
  "coverage": {
    "code": "Код:",
    "coverageStatus": "Статус страховки",
    "inProgress": "В процессе",
    "isCovered": "{{name}} застрахован(а) через {{programs}}.",
    "lastCheck": "Последняя проверка",
    "lastCheckDateFormat": "DD.MM.YYYY",
    "lastCheckWithDate": "Последняя проверка {{date}}",
    "noMatchingRecord": "Мы не смогли найти информацию о вашей страховке. Проверьте данные и попробуйте снова.",
    "planName": "Название плана",
    "primaryCareProvider": "Основной врач",
    "programCoverage": "Страховка {{program}}",
    "programListing": {
      "medicaid": "<bold>Medicaid</bold>",
      "medicare": "<bold>Medicare</bold>",
      "medicareAndMedicaid": "<bold>Medicare</bold> и <bold>Medicaid</bold>"
    },
    "serviceTypes": "Виды услуг",
    "status": {
      "checking": "Проверяем страховку...",
      "checkingShort": "Проверка...",
      "covered": "Застрахован",
      "coveredBy": "Страховка: {{ programs }}",
      "notCovered": "Не застрахован",
      "unknown": "Статус неизвестен",
      "unknownShort": "Неизвестно"
    },
    "updateProfileInformation": "Обновить данные профиля"
  },
  "createPasswordScreen": {
    "passwordInputLabel": "Пароль",
    "passwordInputPlaceholder": "Придумайте пароль",
    "passwordRequirement": "Минимум 10 символов.",
    "subtitle": "Защитите свой аккаунт надежным паролем.",
    "title": "Создайте пароль"
  },
  "createUsernameAccountScreen": {
    "passwordInputLabel": "Пароль",
    "passwordInputPlaceholder": "Придумайте пароль",
    "subtitle": "Защитите свой аккаунт надежным паролем.",
    "title": "Создайте пароль"
  },
  "dateOfBirthInput": {
    "dayPlaceholder": "ДД",
    "monthPlaceholder": "ММ",
    "yearPlaceholder": "ГГГГ"
  },
  "eligibilityHouseholdIncomeScreen": {
    "description1": "Указывайте доход ДО налогов. Если вы самозанятый, указывайте чистую прибыль (после расходов на бизнес).",
    "description2": "Сюда входит примерный доход всех членов семьи:",
    "hideBreakdown": "Скрыть расчеты",
    "householdIncomeCalculator": {
      "annualDescription": "Введите примерный годовой доход каждого, чтобы посчитать итог",
      "biWeeklyDescription": "Введите доход за каждые 2 недели",
      "monthlyDescription": "Введите месячный доход каждого",
      "period": {
        "annual": "год",
        "biWeekly": "2 недели",
        "monthly": "месяц"
      },
      "title": "Посчитайте свой доход",
      "totalIncomeTitle": "Общий доход семьи:",
      "totalIncomeValue": "{{total}} /{{period}}",
      "useRange": "Выбрать {{label}}"
    },
    "incomePeriod": {
      "annual": "В год",
      "biWeekly": "Каждые 2 недели",
      "monthly": "В месяц"
    },
    "incomeRange": {
      "0-1800": "$0 - $1 800",
      "0-3700": "$0 - $3 700",
      "0-44400": "$0 - $44 400",
      "1600-2600": "$1 600 - $2 600",
      "2500-3000": "$2 500 - $3 000",
      "3000-3300": "$3 000 - $3 300",
      "3300+": "$3 300 и выше",
      "3500-5600": "$3 500 - $5 600",
      "43000-67000": "$43 000 - $67 000",
      "5500-6500": "$5 500 - $6 500",
      "6500-7000": "$6 500 - $7 000",
      "66000-78000": "$66 000 - $78 000",
      "7000+": "$7 000 и выше",
      "78000-83000": "$78 000 - $83 000",
      "83000+": "$83 000 и выше"
    },
    "showBreakdown": "Нужна помощь с расчетом? Показать детали",
    "title": "Какой примерный доход у вашей семьи?",
    "updateError": "Не удалось сохранить информацию о вашем доходе. Попробуйте еще раз."
  },
  "eligibilityHouseholdMembers": {
    "title": "Ваша семья",
    "you": "Вы"
  },
  "eligibilityLiveAndCareScreen": {
    "description": "Дети должны <bold>жить с вами более полугода</bold>, и вы должны <bold>оплачивать больше половины</bold> их годовых расходов (еда, жилье, учеба, лечение).",
    "formDescription": "Добавьте детей, внуков или приемных детей до 19 лет, которые живут с вами и которых вы содержите.",
    "formTitle": "Расскажите о детях, которых вы содержите",
    "supporterDescription": "Они должны <bold>жить с {{supporterFirstName}} более полугода</bold>, и {{supporterFirstName}} должен <bold>оплачивать больше половины</bold> их годовых расходов.",
    "supporterFormDescription": "Добавьте детей, внуков или приемных детей до 19 лет, которые живут с {{supporterFirstName}}.",
    "supporterFormTitle": "Расскажите о детях {{supporterFirstName}}",
    "supporterTitle": "Живет ли {{supporterFirstName}} с детьми до 19 лет и заботится ли о них?",
    "title": "Живете ли вы с детьми до 19 лет и заботитесь ли о них?"
  },
  "eligibilityMaritalStatusScreen": {
    "description": "Это поможет нам понять состав семьи и определить подходящие программы.",
    "formDescription": "Нам нужны базовые данные о вашем супруге или партнере.",
    "formTitle": "Расскажите о вашем супруге или партнере",
    "supporterFormDescription": "Нам нужны базовые данные о супруге или партнере {{supporterFirstName}}.",
    "supporterFormTitle": "О супруге или партнере {{supporterFirstName}}",
    "supporterTitle": "Какое семейное положение у {{supporterFirstName}}?",
    "title": "Какое у вас семейное положение?"
  },
  "eligibilityParentGuardianStudentScreen": {
    "description": "Вы должны <bold>оплачивать больше половины</bold> их годовых расходов (еда, жилье, учеба, лечение).",
    "formDescription": "Добавьте студентов очного отделения 18–21 года, для которых вы являетесь родителем или опекуном и которых вы содержите.",
    "formTitle": "Расскажите о студенте, которого вы содержите",
    "supporterDescription": "{{supporterFirstName}} должен <bold>оплачивать более половины</bold> их годовых расходов.",
    "supporterFormDescription": "Добавьте студентов 18–21 года, которых содержит {{supporterFirstName}}.",
    "supporterFormTitle": "О студенте, которого содержит {{supporterFirstName}}",
    "supporterTitle": "Является ли {{supporterFirstName}} родителем или опекуном студента 18–21 года на иждивении?",
    "title": "Вы родитель или опекун студента 18–21 года, которого вы содержите?"
  },
  "eligibilitySomeoneSupportsYou": {
    "description": "Сюда входят расходы на еду, жилье, учебу и лечение.",
    "errors": {
      "updateFailed": "Не удалось сохранить изменения. Попробуйте еще раз."
    },
    "formDescription": "Добавьте человека, который оплачивает более половины ваших расходов (например, родитель или опекун).",
    "formTitle": "Расскажите о человеке, который вас содержит",
    "options": {
      "disabled": "Да, я инвалид и живу с человеком, который меня содержит.",
      "fullTimeStudent": "Да, я студент-очник, и меня содержат родители или опекуны.",
      "personSupportsMe": "Да, я живу более полугода с человеком, который меня содержит.",
      "relativeSupportsMe": "Да, я живу более полугода с родственником, который меня содержит."
    },
    "title": "Оплачивает ли кто-то более половины ваших годовых расходов?"
  },
  "eligibilitySpecialConditionsScreen": {
    "addDetails": "Добавить детали",
    "conditions": {
      "blind": "Кто-то слеп",
      "breastCancer": "У кого-то рак груди",
      "cervicalCancer": "У кого-то рак шейки матки",
      "disabled": "Кто-то имеет инвалидность (SSDI)",
      "fosterCare": "Кто-то был в приемной семье по достижении 18 лет",
      "pregnant": "Кто-то беременен"
    },
    "description": "Отметьте, если это относится к кому-то из членов семьи.",
    "errors": {
      "allUpdatesFailed": "Не удалось сохранить изменения. Попробуйте еще раз."
    },
    "pregnancyDetails": {
      "estimatedDueDate": "Ожидаемая дата родов",
      "numberOfBabies": "Сколько детей ожидается",
      "title": "Детали беременности"
    },
    "pregnancyInfo": {
      "babiesWithCount_one": "{{count}} ребенок • Роды {{date}}",
      "babiesWithCount_other": "{{count}} детей • Роды {{date}}"
    },
    "title": "Особые случаи в семье"
  },
  "eligibilitySupportDisabledIndividualScreen": {
    "description": "Это может быть кто угодно — ребенок, брат/сестра, дедушка/бабушка. Вы должны <bold>оплачивать больше половины</bold> их расходов.",
    "formDescription": "Добавьте людей с инвалидностью, которые живут с вами круглый год и которых вы содержите.",
    "formTitle": "О человеке с инвалидностью, которого вы содержите",
    "supporterDescription": "{{supporterFirstName}} должен <bold>оплачивать больше половины</bold> их годовых расходов.",
    "supporterFormDescription": "Добавьте людей с инвалидностью, которых содержит {{supporterFirstName}}.",
    "supporterFormTitle": "О человеке, которого содержит {{supporterFirstName}}",
    "supporterTitle": "Содержит ли {{supporterFirstName}} инвалида, живущего с ним круглый год?",
    "title": "Вы содержите человека с инвалидностью, который живет с вами круглый год?"
  },
  "eligibilitySupportOtherRelativesScreen": {
    "description": "Они должны <bold>жить с вами более полугода</bold>, и вы должны <bold>оплачивать больше половины</bold> их расходов. Сюда входят родственники, мачехи/отчимы, родственники супругов.",
    "formDescription": "Добавьте родственников, которые живут с вами и которых вы финансово поддерживаете.",
    "formTitle": "О родственниках, которых вы содержите",
    "supporterDescription": "{{supporterFirstName}} должен <bold>оплачивать больше половины</bold> их годовых расходов.",
    "supporterFormDescription": "Добавьте родственников, которых содержит {{supporterFirstName}}.",
    "supporterFormTitle": "О родственниках, которых содержит {{supporterFirstName}}",
    "supporterTitle": "Содержит ли {{supporterFirstName}} других родственников, живущих с ним?",
    "title": "Вы содержите других родственников, которые живут с вами?"
  },
  "homeScreen": {
    "addMember": "Добавить члена семьи",
    "applicationSubmittedCard_multiple": "Вы подали заявления на <programs /> для {{memberNames}}. Мы рассмотрим их и свяжемся с вами, если что-то понадобится.",
    "applicationSubmittedCard_single": "Вы подали заявление на <programs /> для {{memberNames}}. Мы рассмотрим его и свяжемся с вами, если что-то понадобится.",
    "applicationSubmittedCard_singleMarketplace": "Вы подали заявление на <programs /> для {{memberNames}}. Мы рассмотрим его и свяжемся с вами, если что-то понадобится.",
    "checkEligibility": "Проверить право на льготы",
    "checkEligibilityCompact": "Проверить право на льготы",
    "devScenarioActive": "Активен смоделированный сценарий — на панели показаны тестовые данные.",
    "devScenarioReset": "Сбросить",
    "eligibilityCardCompactNotStarted": "Узнайте, на какие программы вы можете рассчитывать",
    "eligibilityCardCompactStarted": "Продолжите, чтобы узнать, на какие программы вы можете рассчитывать",
    "eligibilityCardNotStarted": "Начните простую проверку, чтобы узнать, на какие программы может рассчитывать ваша семья",
    "eligibilityCardStarted": "Продолжите проверку, чтобы узнать доступные программы",
    "household": "Семья",
    "logout": "Выйти",
    "nextSteps": "Дальнейшие шаги",
    "recheckEligibility": "Проверить снова"
  },
  "householdMemberScreen": {
    "applicantDocuments": "Документы заявителя",
    "checkCoverage": "Проверить страховку",
    "deleteButton": "Удалить {{memberFullName}} из семьи",
    "deleteDialog": {
      "description": "Это навсегда удалит {{memberFullName}} из вашей семьи. Все данные и документы будут стерты без возможности восстановления.",
      "title": "Удалить члена семьи"
    },
    "deleteToast": {
      "error": "Мы не смогли удалить этого члена семьи. Попробуйте еще раз.",
      "success": "Член семьи успешно удален"
    },
    "profileInformation": "Информация профиля"
  },
  "landingScreen": {
    "goToAuth": "Перейти к авторизации"
  },
  "languageSelectorModal": {
    "title": "Выберите язык"
  },
  "languages": {
    "arabicDescription": "Арабский",
    "chineseSimplifiedDescription": "Китайский (упрощенный)",
    "englishDescription": "Английский",
    "haitianCreoleDescription": "Гаитянский креольский",
    "russianDescription": "Русский",
    "spanishDescription": "Испанский",
    "tagalogDescription": "Тагальский",
    "vietnameseDescription": "Вьетнамский"
  },
  "memberFormSubmission": {
    "error": "Не удалось сохранить изменения. Попробуйте еще раз.",
    "success": "Данные успешно обновлены"
  },
  "mfaPhoneScreen": {
    "phoneNumberLabel": "Номер телефона",
    "phoneNumberPlaceholder": "(555) 000-0000",
    "sendVerificationCodeText": "Мы отправим вам код подтверждения.",
    "subtitle": "Это нужно для защиты вашего аккаунта.",
    "title": "Ваш номер телефона?"
  },
  "mfaVerifyScreen": {
    "getNewCode": "Получить новый код",
    "subtitle": "Введите 6-значный код, который мы отправили на\n<bold>{{phoneNumber}}</bold>",
    "title": "Мы отправили вам код",
    "verificationCodeLabel": "Код подтверждения"
  },
  "notFound": {
    "cta": "На главную",
    "description": "Страница, которую вы ищете, больше не существует.",
    "title": "Страница не найдена."
  },
  "npsSurveyScreen": {
    "highFeedbackLabel": "Что вам больше всего понравилось в Pointcare? (необязательно)",
    "highFeedbackPlaceholder": "Расскажите, что вам особенно понравилось",
    "lowFeedbackLabel": "Что мы могли бы улучшить? (необязательно)",
    "lowFeedbackPlaceholder": "Расскажите, что пошло не так...",
    "mediumFeedbackLabel": "Что помогло бы вам поставить 10? (необязательно)",
    "mediumFeedbackPlaceholder": "Что сделало бы это лучше...",
    "scaleHighLabel": "→ Очень вероятно",
    "scaleLowLabel": "→ Совсем маловероятно",
    "submitButton": "Отправить отзыв",
    "subtitle": "Ваши ответы никогда не передаются программам, в которые вы подавали заявку.",
    "success": "Отзыв успешно отправлен.",
    "testimonialLabel": "Можем ли мы разместить ваш отзыв на нашем сайте, чтобы помочь большему числу людей найти страховое покрытие? Мы используем только ваше имя.",
    "title": "Насколько вероятно, что вы порекомендуете Pointcare другу или члену семьи?"
  },
  "onboarding": {
    "benefits": {
      "description": "Pointcare помогает более 1.8 млн пациентов в США находить и сохранять страховку.",
      "firstItem": "Узнайте, кто имеет право, за 5 мин",
      "firstItem_AGING_INTO_MEDICARE": "Найдите подходящий план Medicare",
      "firstItem_AGING_INTO_MEDICARE_awareness": "Следите за важными сроками",
      "firstItem_LAPSE": "Узнайте, кто имеет право, за 5 мин",
      "firstItem_QR_CODE": "Узнайте, кто имеет право, за 5 мин",
      "firstItem_RECURRING_WORK_REQUIREMENT": "Не пропускайте важные сроки",
      "firstItem_REDETERMINATION": "Не пропускайте важные сроки",
      "firstItem_SELF_PAY_CONVERSION": "Узнайте, кто имеет право, за 5 мин",
      "firstItem_SERVICE_INTRODUCTION_medicaid": "Не пропускайте важные сроки",
      "firstItem_SERVICE_INTRODUCTION_medicare": "Проверьте все льготы за 5 мин",
      "freeToUse": "Бесплатная помощь — без скрытых платежей",
      "infoIsPrivate": "Ваши данные остаются в безопасности",
      "title": "{{clinicName}} вместе с Pointcare поддерживает вашу семью",
      "titleNoClinic": "Pointcare здесь, чтобы помочь вашей семье"
    },
    "buttons": {
      "createMyProfile": "Создать мой профиль",
      "getStarted": "Начать"
    },
    "concerns": {
      "description": "Выберите, что для вас важнее всего — мы покажем, как можем помочь.",
      "description_SERVICE_INTRODUCTION_medicare": "Выберите вариант, который лучше всего описывает страховку.",
      "title": "Что больше всего мешает вам получить страховку для семьи?",
      "title_SERVICE_INTRODUCTION_medicare": "Какая страховка Medicare у вашей семьи?"
    },
    "figuringOutWhenToRenew": {
      "option": "Понять, когда продлевать",
      "subtext": "Мы проследим за сроками для всех и напомним вам заранее."
    },
    "figuringOutWhenToSubmitRequirements": {
      "option": "Понять сроки подачи документов",
      "subtext": "Мы будем следить за сроками подачи данных о работе для всей семьи."
    },
    "imNotSure": {
      "option": "Я не уверен(а)",
      "subtext": "Мы позаботимся о том, чтобы план подходил каждому."
    },
    "intro": {
      "description": "Многие не платят ничего. Другие — всего $20–30 в месяц. Мы зададим пару вопросов, чтобы найти лучший вариант для каждого.",
      "description_AGING_INTO_MEDICARE": "Сейчас вам может приходить много предложений. Как ваш врач, мы поможем выбрать правильный план.",
      "description_AGING_INTO_MEDICARE_awareness": "Сейчас вам может приходить много предложений. Как ваш врач, мы поможем выбрать правильный план.",
      "description_LAPSE": "7 из 10 человек могут снова получить бесплатную или недорогую страховку. Мы поможем на каждом этапе.",
      "description_QR_CODE": "Многие не платят ничего. Другие — всего $20–30 в месяц. Мы найдем лучший вариант для каждого.",
      "description_RECURRING_WORK_REQUIREMENT": "Новый закон требует подтверждения дохода. Мы проверим, нужно ли это вам, и поможем всё оформить.",
      "description_REDETERMINATION": "Вам нужно обновить данные семьи, чтобы сохранить страховку. Мы поможем во всём разобраться.",
      "description_SELF_PAY_CONVERSION": "Многие не платят ничего. Другие — всего $20–30 в месяц. Мы найдем лучший вариант для каждого.",
      "description_SERVICE_INTRODUCTION_medicaid": "Мы будем следить за страховкой, помогать с продлением и отвечать на вопросы — бесплатно.",
      "description_SERVICE_INTRODUCTION_medicare": "Мы поможем понять вашу страховку, найти доп. льготы и ничего не упустить.",
      "title": "Получить страховку — это просто. Ваша семья может претендовать на <colorEmphasis>бесплатные или недорогие планы</colorEmphasis>.",
      "title_AGING_INTO_MEDICARE": "Похоже, кто-то в вашей семье имеет право на Medicare уже <colorEmphasis>{{count}} мес.</colorEmphasis> Мы здесь, чтобы помочь.",
      "title_AGING_INTO_MEDICARE_awareness_one": "Кто-то в вашей семье получит право на Medicare <colorEmphasis>через {{monthsToTurning65}} месяц</colorEmphasis>.",
      "title_AGING_INTO_MEDICARE_awareness_other": "Кто-то в вашей семье получит право на Medicare <colorEmphasis>через {{monthsToTurning65}} мес.</colorEmphasis>.",
      "title_AGING_INTO_MEDICARE_one": "Кто-то в вашей семье имеет право на Medicare уже <colorEmphasis>{{count}} месяц</colorEmphasis>.",
      "title_AGING_INTO_MEDICARE_other": "Кто-то в вашей семье имеет право на Medicare уже <colorEmphasis>{{count}} мес.</colorEmphasis>.",
      "title_AGING_INTO_MEDICARE_zero": "Кто-то в вашей семье получил право на Medicare <colorEmphasis>с этого месяца</colorEmphasis>.",
      "title_LAPSE": "Похоже, страховка {{payerName}} у кого-то из близких закончилась <colorEmphasis>{{lapseDate}}</colorEmphasis>. Мы поможем её вернуть.",
      "title_QR_CODE": "Ваша семья может получить <colorEmphasis>бесплатную или недорогую страховку</colorEmphasis>. Давайте проверим.",
      "title_RECURRING_WORK_REQUIREMENT_one": "Срок подтверждения работы по {{payerName}} наступит <colorEmphasis>через {{count}} месяц</colorEmphasis>. Давайте сохраним страховку.",
      "title_RECURRING_WORK_REQUIREMENT_other": "Срок подтверждения работы по {{payerName}} наступит <colorEmphasis>через {{count}} мес.</colorEmphasis>. Давайте сохраним страховку.",
      "title_RECURRING_WORK_REQUIREMENT_zero": "Срок подтверждения работы по {{payerName}} наступает <colorEmphasis>в этом месяце</colorEmphasis>. Давайте сохраним страховку.",
      "title_REDETERMINATION_one": "Срок продления {{payerName}} наступит <colorEmphasis>через {{count}} месяц</colorEmphasis>. Давайте сохраним страховку.",
      "title_REDETERMINATION_other": "Срок продления {{payerName}} наступит <colorEmphasis>через {{count}} мес.</colorEmphasis>. Давайте сохраним страховку.",
      "title_REDETERMINATION_zero": "Срок продления {{payerName}} наступает <colorEmphasis>в этом месяце</colorEmphasis>. Давайте сохраним страховку.",
      "title_SERVICE_INTRODUCTION_medicaid": "Мы поможем вашей семье <colorEmphasis>сохранить страховку {{payerName}}.</colorEmphasis>",
      "title_SERVICE_INTRODUCTION_medicare": "Ваша семья <colorEmphasis>получает максимум от {{payerName}}?</colorEmphasis> Мы поможем узнать."
    },
    "keepingMyCurrentDoctors": {
      "option": "Сохранить своих врачей",
      "subtext": "Мы поможем найти план, в который входят ваши врачи."
    },
    "meetingRequirements": {
      "option": "Выполнение требований",
      "subtext": "Мы поможем каждому с выполнением и подачей требований по работе."
    },
    "missingEnrolmentDeadline": {
      "option": "Пропуск сроков записи",
      "subtext": "Мы сообщим, когда нужно записаться, чтобы избежать штрафов."
    },
    "nextSteps": {
      "step1Description": "Расскажите о себе",
      "step1Duration": "2 мин",
      "step1Title": "Создать профиль",
      "step2Description": "Программы для вашей семьи",
      "step2Description_AGING_INTO_MEDICARE": "Проверить текущий статус",
      "step2Description_AGING_INTO_MEDICARE_awareness": "Проверить текущий статус",
      "step2Description_LAPSE": "Программы для вашей семьи",
      "step2Description_QR_CODE": "Программы для вашей семьи",
      "step2Description_RECURRING_WORK_REQUIREMENT": "Мы проверим статус каждого",
      "step2Description_RECURRING_WORK_REQUIREMENT_awareness": "Мы проверим статус каждого",
      "step2Description_REDETERMINATION": "Наша команда свяжется с вами",
      "step2Description_REDETERMINATION_awareness": "Включая контактную информацию",
      "step2Description_SELF_PAY_CONVERSION": "Программы для вашей семьи",
      "step2Description_SERVICE_INTRODUCTION_medicaid": "Проверить текущий статус",
      "step2Description_SERVICE_INTRODUCTION_medicare": "Проверить текущий статус",
      "step2Description_SERVICE_INTRODUCTION_medicare_partABorD": "Проверить текущий статус",
      "step2Duration": "5 мин",
      "step2Duration_AGING_INTO_MEDICARE": "2 мин",
      "step2Duration_AGING_INTO_MEDICARE_awareness": "2 мин",
      "step2Duration_LAPSE": "5 мин",
      "step2Duration_QR_CODE": "5 мин",
      "step2Duration_RECURRING_WORK_REQUIREMENT": "5 мин",
      "step2Duration_RECURRING_WORK_REQUIREMENT_awareness": "5 мин",
      "step2Duration_REDETERMINATION": "2 мин",
      "step2Duration_SELF_PAY_CONVERSION": "5 мин",
      "step2Duration_SERVICE_INTRODUCTION_medicaid": "2 мин",
      "step2Duration_SERVICE_INTRODUCTION_medicare": "2 мин",
      "step2Duration_SERVICE_INTRODUCTION_medicare_partABorD": "2 мин",
      "step2Title": "Найти варианты",
      "step2Title_AGING_INTO_MEDICARE": "Проверить страховку",
      "step2Title_AGING_INTO_MEDICARE_awareness": "Проверить страховку",
      "step2Title_LAPSE": "Найти варианты",
      "step2Title_QR_CODE": "Найти варианты",
      "step2Title_RECURRING_WORK_REQUIREMENT": "Проверить требования",
      "step2Title_RECURRING_WORK_REQUIREMENT_awareness": "Проверить требования",
      "step2Title_REDETERMINATION": "Запросить поддержку в продлении",
      "step2Title_REDETERMINATION_awareness": "Добавить данные семьи",
      "step2Title_SELF_PAY_CONVERSION": "Найти варианты",
      "step2Title_SERVICE_INTRODUCTION_medicaid": "Проверить страховку",
      "step2Title_SERVICE_INTRODUCTION_medicare": "Проверить страховку",
      "step2Title_SERVICE_INTRODUCTION_medicare_partABorD": "Проверить страховку",
      "step3Description": "Остальное мы берем на себя!",
      "step3Description_AGING_INTO_MEDICARE": "Остальное мы берем на себя!",
      "step3Description_AGING_INTO_MEDICARE_awareness": "Мы будем держать вас в курсе",
      "step3Description_LAPSE": "Остальное мы берем на себя!",
      "step3Description_QR_CODE": "Остальное мы берем на себя!",
      "step3Description_RECURRING_WORK_REQUIREMENT": "Мы поможем вам пройти этот путь",
      "step3Description_RECURRING_WORK_REQUIREMENT_awareness": "Мы поможем выполнить требования",
      "step3Description_REDETERMINATION": "Мы поможем вам пройти этот путь",
      "step3Description_REDETERMINATION_awareness": "Мы подготовим вас заранее",
      "step3Description_SELF_PAY_CONVERSION": "Остальное мы берем на себя!",
      "step3Description_SERVICE_INTRODUCTION_medicaid": "Мы предупредим вас заранее",
      "step3Description_SERVICE_INTRODUCTION_medicare": "Узнайте, что входит в планы каждого",
      "step3Description_SERVICE_INTRODUCTION_medicare_partABorD": "Расширить льготы",
      "step3Duration": "15 мин",
      "step3Duration_SERVICE_INTRODUCTION_medicare": "1 мин",
      "step3Title": "Отправить заявку",
      "step3Title_AGING_INTO_MEDICARE": "Подать на Medicare",
      "step3Title_AGING_INTO_MEDICARE_awareness": "Готовность к Medicare",
      "step3Title_LAPSE": "Отправить заявку",
      "step3Title_QR_CODE": "Отправить заявку",
      "step3Title_RECURRING_WORK_REQUIREMENT": "Подать данные",
      "step3Title_RECURRING_WORK_REQUIREMENT_awareness": "Следить за требованиями",
      "step3Title_REDETERMINATION": "Подать на продление",
      "step3Title_REDETERMINATION_awareness": "Следить за продлением",
      "step3Title_SELF_PAY_CONVERSION": "Отправить заявку",
      "step3Title_SERVICE_INTRODUCTION_medicaid": "Не пропустите сроки",
      "step3Title_SERVICE_INTRODUCTION_medicare": "Ваши льготы",
      "step3Title_SERVICE_INTRODUCTION_medicare_partABorD": "Варианты Medicare",
      "title": "Готовы застраховать семью?",
      "title_RECURRING_WORK_REQUIREMENT": "Сохраним страховку вашей семьи",
      "title_RECURRING_WORK_REQUIREMENT_awareness": "Сохраним страховку вашей семьи",
      "title_REDETERMINATION": "Сохраним страховку вашей семьи",
      "title_REDETERMINATION_awareness": "Сохраним страховку вашей семьи",
      "title_SERVICE_INTRODUCTION_medicaid": "Сохраним страховку вашей семьи",
      "title_SERVICE_INTRODUCTION_medicare": "Сохраним страховку вашей семьи",
      "title_SERVICE_INTRODUCTION_medicare_partABorD": "Сохраним страховку вашей семьи"
    },
    "notKnowingHowToGetCovered": {
      "option": "Не знаю, как получить страховку",
      "subtext": "Мы пошагово покажем, что нужно сделать, чтобы застраховать всех."
    },
    "notKnowingImCovered": {
      "option": "Не знаю, кто застрахован",
      "subtext": "Мы проверим наличие страховки у каждого и поможем её получить.",
      "subtext_RECURRING_WORK_REQUIREMENT": "Мы проверим страховку каждого и поможем, если она нужна.",
      "subtext_RECURRING_WORK_REQUIREMENT_awareness": "Мы проверим страховку каждого и поможем, если она нужна.",
      "subtext_REDETERMINATION": "Мы проверим страховку каждого и поможем, если она нужна.",
      "subtext_REDETERMINATION_awareness": "Мы проверим страховку каждого и поможем, если она нужна.",
      "subtext_SERVICE_INTRODUCTION_medicaid": "Мы проверим страховку каждого и поможем, если она нужна."
    },
    "paperwork": {
      "option": "Слишком много бумаг",
      "subtext": "Мы возьмем на себя все документы — от оформления до продления.",
      "subtext_SERVICE_INTRODUCTION": "Мы работаем от имени врача вашей семьи, чтобы найти лучший вариант для здоровья."
    },
    "partAB": {
      "option": "Части A и B (Medicare)",
      "subtext": "Мы найдем лучший вариант: текущий план или Medicare Advantage (Часть C)."
    },
    "partABD": {
      "option": "Части A, B и D (Medicare + лекарства)",
      "subtext": "Мы найдем лучший вариант для каждого."
    },
    "partC": {
      "option": "Часть C (Medicare Advantage)",
      "subtext": "Мы убедимся, что план всё еще подходит каждому."
    },
    "payingForDoctor": {
      "option": "Оплата врачей и лекарств",
      "subtext": "Мы поможем найти страховку, которая снизит расходы на врачей и аптеки."
    },
    "somethingElse": {
      "option": "Что-то другое",
      "subtext": "Мы поможем всем получить и сохранить страховку.",
      "subtext_AGING_INTO_MEDICARE": "Мы пошагово поможем вам получить Medicare.",
      "subtext_AGING_INTO_MEDICARE_awareness": "Мы пошагово поможем вам получить Medicare.",
      "subtext_RECURRING_WORK_REQUIREMENT": "Мы поможем всем сохранить страховку без сюрпризов.",
      "subtext_RECURRING_WORK_REQUIREMENT_awareness": "Мы поможем всем сохранить страховку без сюрпризов.",
      "subtext_REDETERMINATION": "Забудьте о путанице в бумагах. Мы поможем сохранить страховку.",
      "subtext_REDETERMINATION_awareness": "Забудьте о путанице в бумагах. Мы поможем сохранить страховку.",
      "subtext_SERVICE_INTRODUCTION_medicaid": "Забудьте о путанице в бумагах. Мы поможем сохранить страховку.",
      "subtext_SERVICE_INTRODUCTION_medicare": "Мы убедимся, что план всё еще подходит каждому."
    },
    "submittingRenewals": {
      "option": "Подача на продление",
      "subtext": "Мы берем продление на себя. Нужно лишь ответить на пару вопросов."
    },
    "tooManyMedicareAdsAndCalls": {
      "option": "Слишком много рекламы и звонков Medicare",
      "subtext": "Мы поможем отсечь лишнее и найти нужный план."
    },
    "variants": {
      "improvedVerbiage": {
        "benefits": {
          "description": "Pointcare помогает более 1.8 млн пациентов находить и сохранять страховку.",
          "firstItem_LAPSE": "Посмотрите, кто имеет право, за 5 мин",
          "infoIsPrivate": "Ваши данные у нас в безопасности",
          "title": "{{clinicName}} работает с Pointcare, чтобы помочь вашей семье"
        },
        "concerns": {
          "description_LAPSE": "Выберите, что для вас важнее всего, и мы покажем, как можем помочь.",
          "title_LAPSE": "Что сложнее всего в получении страховки для вашей семьи?"
        },
        "intro": {
          "description_LAPSE": "Большинство людей снова получают право на бесплатную или недорогую страховку. Мы поможем на каждом этапе.",
          "title_LAPSE": "Кто-то из вашей семьи потерял страховку {{payerName}} <colorEmphasis>{{lapseDate}}</colorEmphasis>. Мы поможем её вернуть."
        },
        "nextSteps": {
          "step2Description_LAPSE": "Узнайте, на что может претендовать ваша семья"
        },
        "paperwork": {
          "option": "Запутанные документы"
        }
      }
    }
  },
  "passwordScreen": {
    "forgotPassword": "Забыли свой пароль?",
    "passwordInputLabel": "Пароль",
    "passwordInputPlaceholder": "Введите ваш пароль",
    "resetPasswordInstructions": "Мы отправили ссылку для сброса пароля на <bold>{{email}}</bold>. Откройте её, чтобы создать новый пароль.",
    "subtitle": "Пожалуйста, введите пароль от вашего аккаунта.",
    "title": "Введите пароль",
    "usernameResetUnavailable": "Для аккаунтов с именем пользователя сброс пароля по почте недоступен. Позвоните нам, и мы поможем."
  },
  "profileInformationScreen": {
    "addressComplement": "Кв., офис, строение (необязательно)",
    "checkCoverage": "Тест проверки страховки",
    "coverageStatus": "Статус страховки: {{status}}",
    "dateOfBirth": "Дата рождения",
    "email": "Электронная почта",
    "firstName": "Имя",
    "homeAddress": "Домашний адрес",
    "lastName": "Фамилия",
    "mailingAddress": "Почтовый адрес",
    "mailingAddressComplement": "Кв., блок, здание, а/я (необязательно)",
    "medicaidCaseNumber": "Номер дела Medicaid (необязательно)",
    "medicaidSubscriberId": "ID участника Medicaid (необязательно)",
    "noHomeAddress": "Нет домашнего адреса",
    "noMailingAddress": "Нет почтового адреса",
    "phoneNumber": "Номер телефона",
    "socialSecurityNumber": "Номер соцстрахования (SSN)",
    "useDifferentMailingAddress": "Использовать другой почтовый адрес"
  },
  "recheckEligibilityScreen": {
    "button": "Проверить снова",
    "title": "Перед повторной проверкой убедитесь, что данные семьи актуальны."
  },
  "redeterminationScreen": {
    "addressInformation": "Обновить информацию об адресе",
    "alreadyMailedForm": "Уже отправил форму или планирую скоро",
    "caseNumberDescription": "Мы используем номер вашего дела, чтобы быстрее оформить продление!\n\nИщите его в форме продления или в другом письме от вашего государственного агентства о вашем страховом покрытии.",
    "caseNumberDescription_PENDING_FORM": "Мы используем номер вашего дела, чтобы быстрее оформить продление!\n\nИщите его в письмах от вашего государственного агентства о вашем страховом покрытии.",
    "caseNumberLabel": "Номер дела",
    "caseNumberPlaceholder": "Введите номер дела",
    "caseNumberTitle": "Добавим номер вашего дела (необязательно)",
    "description": "Выберите подходящий вариант",
    "haventReceivedForm": "Еще не получил форму",
    "receivedForm": "Получил форму, нужна помощь в заполнении",
    "returnToDashboard": "Вернуться на главную",
    "reviewAddress": "Пожалуйста, проверьте и подтвердите домашний и почтовый адреса всех членов семьи. Это гарантирует, что форма продления придёт на правильный адрес.",
    "successDescription": "Ваше продление улажено. Мы свяжемся с вами, если что-то изменится.",
    "successDescription_CALL_BACK": "Наши специалисты свяжутся с вами в течение 1–2 рабочих дней, чтобы завершить продление.",
    "successDescription_PENDING_FORM": "Форма продления должна прийти по указанному адресу. Следите за почтой, электронной почтой и текстовыми сообщениями. Мы обязательно свяжемся с вами до истечения срока.",
    "successTitle": "Всё готово!",
    "successTitle_CALL_BACK": "Мы скоро вам позвоним.",
    "successTitle_PENDING_FORM": "Всё готово!",
    "title": "Срок продления страховки у кого-то из семьи: {{date}}."
  },
  "redeterminations": {
    "cardAggregated_CALL_BACK": "{{total}} продлений Medicaid ожидают звонка — срок до {{dates}}. Следите за телефоном.",
    "cardAggregated_NOT_STARTED": "{{total}} продлений Medicaid нужно начать.",
    "cardAggregated_PENDING_FORM": "Скоро придёт {{total}} форм продления Medicaid. Следите за почтой, эл. почтой и сообщениями.",
    "cardCompact_PENDING_FORM": "Скоро придёт форма продления — срок до {{date}}",
    "card_CALL_BACK": "У кого-то в вашей семье продление Medicaid ожидает звонка — срок до {{date}}. Следите за телефоном.",
    "card_NOT_STARTED": "У кого-то в вашей семье есть продление Medicaid со сроком до {{date}}.",
    "card_PENDING_FORM": "Кому-то в вашей семье скоро придёт форма продления Medicaid — срок до {{date}}. Следите за почтой, эл. почтой и сообщениями.",
    "due": "Срок до {{date}}",
    "medicaidRenewals": "Продления Medicaid",
    "noRenewals": "Продлений пока нет.",
    "startRenewal": "Начать продление",
    "status": "Обратный звонок",
    "status_CALL_BACK": "Запрошен звонок",
    "status_COMPLETED": "Завершено",
    "status_NOT_STARTED": "Не начато",
    "status_PENDING_FORM": "Ожидание формы",
    "title": "Продление страховки",
    "updateStatus": "Обновить статус"
  },
  "registrationCoverageScreen": {
    "description": "Pointcare может найти вашу текущую страховку Medicaid по введенным данным.",
    "title": "Давайте проверим вашу страховку"
  },
  "registrationProfileScreen": {
    "description": "Укажите данные профиля для заполнения заявок."
  },
  "resetPasswordScreen": {
    "confirmPasswordInputLabel": "Подтвердите новый пароль",
    "confirmPasswordInputPlaceholder": "Введите новый пароль ещё раз",
    "invalidResetLink": "Ссылка для сброса пароля недействительна или устарела. Пожалуйста, запросите новую.",
    "passwordInputLabel": "Новый пароль",
    "passwordInputPlaceholder": "Введите новый пароль",
    "subtitle": "Выберите надёжный пароль, который вы раньше не использовали.",
    "title": "Создайте новый пароль",
    "updatePasswordButton": "Обновить пароль"
  },
  "sessionTimedOut": {
    "description": "В целях безопасности мы вышли из системы из-за вашего бездействия. Войдите снова.",
    "loginAgain": "Войти снова",
    "title": "Вы вышли из системы"
  },
  "sessionTimeout": {
    "countdown": "Осталось {{time}}",
    "description": "Ваш сеанс скоро закончится из-за бездействия. Хотите остаться в системе?",
    "logOutNow": "Выйти сейчас",
    "secureSession": "Безопасная сессия",
    "stayLoggedIn": "Остаться",
    "title": "Вы еще здесь?"
  },
  "signatureField": {
    "signaturePrompt": "Поставьте свою подпись"
  },
  "someHouseholdMembersNotUpdated": "Не удалось сохранить изменения для всех. Пожалуйста, проверьте каждого члена семьи.",
  "support": {
    "callUs": "Позвонить нам",
    "callUsAt": "Позвоните нам по номеру <underline>{{phoneNumber}}</underline>"
  },
  "workRequirements": {
    "cardActionCompact_START": "Начать",
    "cardActionCompact_UPLOAD_DOCUMENTS": "Загрузить",
    "cardAction_CONTINUE": "Продолжить проверку требований",
    "cardAction_START": "Начать проверку требований",
    "cardAction_UPLOAD_DOCUMENTS": "Загрузить документы",
    "cardCompact": "Требования к работе Medicaid — срок до {{date}}",
    "card_CONTINUE": "У кого-то в вашей семье есть требования к работе Medicaid со сроком до {{date}}. Завершите проверку: кто выполняет требования, а кто освобождён от них.",
    "card_START": "У кого-то в вашей семье есть требования к работе Medicaid со сроком до {{date}}. Проверьте, выполняете ли вы требования или освобождены от них.",
    "card_UPLOAD_DOCUMENTS": "У кого-то в вашей семье есть требования к работе Medicaid со сроком до {{date}}. Загрузите документы, чтобы выполнить требования вовремя.",
    "caseNumbers": {
      "description": "Мы используем эти номера дел, чтобы подавать документы за вашу семью.",
      "descriptionSingle": "Мы используем этот номер дела, чтобы подать документы о работе для {{name}}.",
      "hint": "Ищите их в письмах от вашего государственного агентства о вашем страховом покрытии.",
      "hintSingle": "Ищите его в письмах от государственного агентства о страховом покрытии для {{name}}.",
      "memberLabel": "{{name}}",
      "title": "Добавим номера дел вашей семьи (необязательно)",
      "titleSingle": "Добавим номер дела для {{name}} (необязательно)"
    },
    "confirmation": {
      "completedDescription": "Наша команда всё проверит и свяжется с вами, если что-то понадобится.",
      "completedTitle": "Поздравляем, вы выполнили <label>требования к работе</label>",
      "description": "Не забудьте выполнить требования до продления страховки {{date}}.",
      "title": "<label>Требования к работе</label>: проверка продолжается",
      "uploadsHint": "Вы сможете завершить загрузку на главной странице, когда откроются следующие месяцы."
    },
    "due": "Срок до <bold>{{date}}</bold>",
    "exemptions": {
      "description": "Выберите все подходящие варианты",
      "groups": {
        "BENEFITS_AND_COVERAGE": "Пособия и страховка",
        "CAREGIVING": "Уход за близкими",
        "HEALTH_AND_RECOVERY": "Здоровье и восстановление",
        "LIFE_SITUATIONS": "Жизненные обстоятельства"
      },
      "options": {
        "CAREGIVER_OF_CHILD_13_OR_YOUNGER": "Родитель или опекун ребёнка в возрасте 13 лет или младше",
        "CAREGIVER_OF_PERSON_WITH_DISABILITY": "Лицо, ухаживающее за человеком с инвалидностью",
        "FOSTER_YOUTH_UNDER_26": "Воспитанник приёмной семьи (сейчас или в прошлом) в возрасте до 26 лет",
        "INCARCERATED_OR_RELEASED_LAST_90_DAYS": "В заключении или освобождены за последние 90 дней",
        "IN_DRUG_OR_ALCOHOL_TREATMENT": "В программе лечения от наркотической или алкогольной зависимости",
        "MEDICALLY_FRAIL": "Серьёзные проблемы со здоровьем (medically frail)",
        "MEETING_SNAP_TANF_WORK_REQUIREMENTS": "Уже выполняет требования к работе SNAP/TANF",
        "NOT_ENROLLED_OR_ELIGIBLE_FOR_MEDICARE": "Не участвует в Medicare и не имеет права на участие",
        "PREGNANT_OR_POSTPARTUM": "Беременность или послеродовой период (до 12 месяцев)",
        "TRIBAL_MEMBER": "Член признанного на федеральном уровне племени коренных американцев",
        "VETERAN_100_PERCENT_DISABILITY": "Ветеран с полной (100%) степенью инвалидности"
      },
      "title": "Подходит ли какое-либо из этих оснований для освобождения?"
    },
    "hours": {
      "communityService": "Общественные работы",
      "description_completed": "Добавьте выполненные часы для {{name}} за {{month}}. Оставьте пустым, если их нет.",
      "description_expected": "Добавьте ожидаемые часы для {{name}} за {{month}}. Оставьте пустым, если их нет.",
      "employment": "Работа",
      "employmentHint": "Укажите часы и ежемесячную оплату. Мы переведём оплату в часы и засчитаем в требование большее значение.",
      "hoursPerMonth": "часов / мес.",
      "jobTraining": "Профобучение",
      "payPerMonth": "$ / мес.",
      "school": "Учёба / ученичество",
      "title": "Укажите часы: {{name}}",
      "totalHours": "Всего часов",
      "totalOf": "<bold>{{total}}</bold> / {{required}}"
    },
    "income": {
      "description": "Выберите всех подходящих или продолжите, если таких нет.",
      "everyone": "Все перечисленные",
      "title": "Кто зарабатывает ${{amount}} или больше в месяц?",
      "titleSingle": "{{name}} зарабатывает ${{amount}} или больше в месяц?"
    },
    "medicaidWorkRequirements": "Требования к работе Medicaid",
    "nextSteps": {
      "complete": "Готово: {{completed}} из {{total}}",
      "description": "Вот что каждому нужно предоставить, чтобы сохранить страховку.",
      "needsMoreHours": "Нужно ещё {{hours}} ч/мес.",
      "offrampDescription": "Чтобы сохранить страховку, нужно выполнять {{hours}} ч одобренной деятельности в месяц. Это может быть работа, профобучение, учёба, ученичество и/или общественные работы.",
      "opensOn": "Откроется {{date}}",
      "proofOfExemption": "Подтверждение освобождения",
      "proofOfWork": "Подтверждение работы ({{month}})",
      "reasonHours": "Указано {{hours}} ч/мес.",
      "reasonIncome": "Зарабатывает ${{amount}} или больше в месяц",
      "reportedOf": "Указано {{hours}} из {{required}} ч/мес.",
      "status_EXEMPT": "Освобождён(а)",
      "status_MEETS_REQUIREMENTS": "Выполняет требования",
      "title": "<label>Требования к работе</label>: дальнейшие шаги",
      "volunteerOpportunities": "Возможности для волонтёрства"
    },
    "noWorkRequirements": "Для вашей семьи нет требований к работе.",
    "progress_ACTION_NEEDED": "Нужны действия",
    "progress_COMPLETED": "Завершено",
    "progress_UP_TO_DATE": "Всё в порядке",
    "recheck": "Проверить требования снова",
    "sectionTitle": "Требования к работе",
    "whatAreDescription": "Новый федеральный закон требует, чтобы некоторые взрослые участники Medicaid работали, проходили профобучение, учились или занимались волонтёрством {{hours}} ч в месяц. Это касается только взрослых в возрасте от {{minAge}} до {{maxAge}} лет.",
    "who": {
      "checkAll": "Проверить всех членов семьи",
      "noEligibleMembers": "В вашей семье нет никого в возрасте от {{minAge}} до {{maxAge}} лет, поэтому никого проверять не нужно.",
      "question": "<bold>Кого вы хотите проверить? Мы узнаем, выполняют ли они требования или освобождены от них, и поможем с дальнейшими шагами.</bold>",
      "title": "Проверьте семью: статус по <label>требованиям к работе</label>"
    }
  }
}
